import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestModel } from '../typings/typing';
@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  constructor(private http: HttpClient) { }

  // Get category list
  getCategoryList(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<RequestModel>('/pages/page',
      params, { headers }
    );
  }
}
